module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "mask over",
    on: {
      "click": function($event) {
        return _vm.confirmAlert(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "alert-box"
  }, [_c('div', {
    staticClass: "body"
  }, [_vm._v(_vm._s(_vm.alertBody))]), _vm._v(" "), (_vm.type == '0') ? _c('div', {
    staticClass: "foot",
    on: {
      "click": function($event) {
        return _vm.confirmAlert(false)
      }
    }
  }, [_vm._v("知道了")]) : _vm._e(), _vm._v(" "), (_vm.type == '1') ? _c('div', {
    staticClass: "foot col2"
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.confirmAlert(false)
      }
    }
  }, [_vm._v("取消")]), _c('span', {
    on: {
      "click": function($event) {
        return _vm.confirmAlert(true)
      }
    }
  }, [_vm._v("确定")])]) : _vm._e(), _vm._v(" "), (_vm.type == '2') ? _c('div', {
    staticClass: "foot",
    on: {
      "click": function($event) {
        return _vm.confirmAlert(true)
      }
    }
  }, [_vm._v("知道了")]) : _vm._e(), _vm._v(" "), (_vm.type == '3') ? _c('div', {
    staticClass: "foot col2"
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.confirmAlert(false)
      }
    }
  }, [_vm._v("返回重选")]), _c('span', {
    on: {
      "click": function($event) {
        return _vm.confirmAlert(true)
      }
    }
  }, [_vm._v("不用了，谢谢")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-32f6f905","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/AlertBox.vue
// module id = 422
// module chunks = 7